module.exports = __webpack_public_path__ + "img/coche.b908df00.png";